import React from 'react';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router';

// Types
import { QuickStartGuideItemIDs } from '../QuickStartGuideItems.constants';

// Hooks
import useUpdateQuickStartGuideFlag from '../useUpdateQuickStartGuideFlag';

// Constants
import PageUrlsConstants from 'Shared/constants/PageUrls.constants';

//Utils
import { trackClickQuickStartGuideCTA } from 'Shared/tracking/tracking';

// Components
import WpIcon from 'Wpds/components/icon/WpIcon';
import { WpButton, WpButtonGroup } from 'Wpds/components/button';
import OAuthButton from 'Shared/components/OAuthButton/OAuthButton';
import { useTranslation } from 'Shared/contexts/TranslationsContext';

// Styles
import './SyncCalendarStep.scss';
import { Illustrations, WpIllustration } from 'Wpds/components/illustration';

type Props = {
  navigateToList: Function;
};

const SyncCalendarStep = ({ navigateToList }: Props) => {
  const history = useHistory();
  const step = QuickStartGuideItemIDs.syncCalendar;
  const { handleSkipItem, hasBeenSet } = useUpdateQuickStartGuideFlag();
  const isSet = hasBeenSet(step);
  const { tr } = useTranslation();

  const dataSources = useSelector(state => state.data_sources);
  const calendarIntegrations = dataSources.filter(ds => ds.isCalendar && ds.connected);
  const isConnected = calendarIntegrations.length > 0;

  const handleSkipClick = () => {
    handleSkipItem(QuickStartGuideItemIDs.syncCalendar);
    navigateToList();
  };

  const handleIntegrationsClick = () => {
    history.push(PageUrlsConstants.INTEGRATIONS);
  };

  const trackClick = () => {
    trackClickQuickStartGuideCTA(step);
  };

  const baseClassName = 'SyncCalendarStep';
  return (
    <div className={baseClassName}>
      <div className={`${baseClassName}__button`}>
        {isConnected ? (
          <>
            <div className={`${baseClassName}__connected-label`}>
              <span className={`${baseClassName}__connected-label__icon`}>
                <WpIcon name="check" />
              </span>
              {tr('perform.onboarding.qsg.sync_calendar.connected_label')}
            </div>
            <WpButton size="lg" onClick={handleIntegrationsClick} variant="tertiary">
              {tr('perform.onboarding.qsg.sync_calendar.manage_integrations')}
            </WpButton>
          </>
        ) : (
          <div onClick={trackClick}>
            <WpButtonGroup stacked spacing="md">
              <OAuthButton
                oauthProvider="google"
                text={tr('perform.onboarding.qsg.sync_calendar.connect_google')}
                withCalendar
              />
              <OAuthButton
                oauthProvider="office365"
                text={tr('perform.onboarding.qsg.sync_calendar.connect_office365')}
                withCalendar
              />
              {!isSet && (
                <WpButton size="lg" onClick={handleSkipClick} variant="tertiary">
                  {tr('perform.onboarding.qsg.common.skip')}
                </WpButton>
              )}
            </WpButtonGroup>
          </div>
        )}
      </div>
      <WpIllustration
        className={`${baseClassName}__image`}
        src={Illustrations.three_people_in_windows_with_purple_bg}
      />
    </div>
  );
};
export default SyncCalendarStep;
